<template>
	<div class="form__room">
        <div class="form___room-item-wrap">
            <div class="form__room-item">
                <div class="form__room-item-avatar">
                    <div class="form__room-item-avatar-img-wrap">
                        <div class="form__room-item-avatar-img f-ava">
                            <img v-if="person === 'ad'" src='../../assets/img/adenisov.png' class="f-ava__img">
                            <img v-if="person === 'vd'" src='../../assets/img/manager.png' class="f-ava__img">
                        </div>
                    </div>
                </div>
                <div class="form__room-item-data-wrap">
                    <div v-if="person === 'ad'" class="form__room-item-data">
                        <div class="form__room-item-data-name">Алексей Денисов</div>
                        <div class="form__room-item-data-status">Управляющий активами</div>
                    </div>
                    <div v-if="person === 'vd'" class="form__room-item-data">
                        <div class="form__room-item-data-name">Служба комплаенс</div>
                        <div class="form__room-item-data-status">Консультант</div>
                    </div>
                </div>
            </div>
            <div class="form__private">
                <div class="form__private-zone-type__zone">
                    <div class="form__private-zone-type__zone-textarea">
                        <textarea name="text" rows="num" v-model="textToSend" :placeholder="getLogin !== null ? textPlaceHolder : textNoReg"
                            @focus="onTextChanged()"
                            :class="['message-text', textChanged ? '' : 'message-untouched']" />
                    </div>
                    <div class="form__private-zone-type__zone-send__icon">
                        <i v-if="getLogin !== null" class="icon-send"
                            @click="sendMessage()">
                        </i>
                    </div>
                </div>
                <scrollbar class="form__private-zone">
                    <div class="form__private-zone-wrap">
                            <template v-for="msg in orderedMessages">
                                <div class="chat__private-zone-message_card-wrap">
                                    <div v-if="msg.t == 'uj'" class="form__private-zone-message_card-in">
                                        <div class = "form__private-zone-message_card-text">
                                        <!-- User's joined -->
                                            Пользователь {{msg.u.username}} присоеденился к чату
                                        </div>
                                        <div class="form__private-zone-message_card-date">
                                            {{$datef(msg.ts.$date)}}
                                        </div>
                                    </div>
                                    <div v-if="msg.t == 'ul'" class="form__private-zone-message_card-in">
                                        <div class = "form__private-zone-message_card-text">
                                            <!-- User's quit-->
                                            Пользователь {{msg.u.username}} покинул чат
                                        </div>
                                        <div class="form__private-zone-message_card-date">
                                            {{$datef(msg.ts.$date)}}
                                        </div>
                                    </div>
                                    <transition enter-active-class="animated fadeIn">
                                        <div v-if="!msg.t"
                                            :class="(msg.u.username === getUserLogin) ? 'form__private-zone-message_card-out' : 'form__private-zone-message_card-in'">
                                            <!-- Just a message -->
                                            <div class = "form__private-zone-message_card-text">
                                                {{msg.msg}}
                                            </div>
                                            <div class="form__private-zone-message_card-date">
                                                {{$datef(msg.ts.$date)}}
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </template>
                    </div>
                </scrollbar>
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { chatMessageStore } from '../../model/chat/chat-message-store.js';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { setTimeout } from 'timers';

export default {
	components: {
        "scrollbar":VuePerfectScrollbar,
    },
	props: {
        chatRoom:{default:null},
        heightBlock:{default:null},
        person:{default:'ad'}
    },
	data() {
		return {
			lastCheckedMsgTime: 0,
            messages: {},
			textPlaceHolder: this.$t('Введите текст сообщения...'),
            textToSend: '',
            textNoReg: this.$t('Для отправки сообщений в чат необходимо авторизоваться/зерегистрироваться на сайте...'),
			textChanged: false,
			orderedMessages: []
		};
	},
	computed: {
		...mapGetters({
	        	lastMessageForRoom: 'chatmessage/lastMessageForRoom',
	        	lastMessageByRoom: 'chatmessage/lastMessageByRoom',
	        	lastMsgTime: 'chatmessage/lastMsgTime',
	        	currentRoomId: 'chat/currentRoomId',
                roomMessages: 'chatmessage/roomMessages',
                loggedIn: 'chat/loggedIn',
                getLogin: 'auth/getInfoUser',
            }),
        getHeightBlock(){
            if(this.heightBlock <= 161)
                return true
            else
                return false
        },
        getUserLogin() {
            if(this.getLogin !== null) {
                return this.getLogin.User.Login.replace(/[@ ,\.]/g,'_');
            } else
            return ' '
        }

	},
	methods: {
        enterRoom(roomId) {
            this.$store.dispatch('chat/enterRoom', roomId);
            for(let i=0; i < this.showRooms.length; i++)
            {
                if(this.showRooms[i]!== this.currentRoomId)
                this.showRooms[i] = 0
            }
        },
        enterDirectRoom(userID, roomName) {
            this.$store.dispatch('chat/enterDirectRoom',userID);
            //this.$store.commit('chat/setCurrentRoomName', roomName);
        },
		onTextChanged() {
			this.textChanged = true;
			this.textToSend = '';
		},
		updateMessages() {
			return;
			let messages = chatMessageStore.getRoomsMessages(this.chatRoom);
			if (!this.messages.length) {
				this.messages = messages;
				return;
            }
		},
		sendMessage() {
			this.$store.dispatch('chat/sendChatMessage', { msg: this.textToSend });
            this.textToSend = '';
		}
	},
	watch: {
		roomMessages(newVal, oldVal) {
			let arr = [];
			for (let id in newVal)
				arr.push(newVal[id]);
			arr.sort((a, b) => {
				return a.ts.$date > b.ts.$date ? 1 : a.ts.$date < b.ts.$date ? -1 : 0;
			});
            this.orderedMessages = arr;
        },
        getLogin: function() {
            this.enterDirectRoom('iqquantum_ad_com');
        },
		lastMsgTime(time, oldVal) {
			//console.log(`lastMessageByRoom: ${this.currentRoomId}`);
			if (!this.currentRoomId) return;
			if (this.lastCheckedMsgTime == time) return;
			this.updateMessages();
			this.lastCheckedMsgTime = time;
        },
        orderedMessages: function (val) {
            this.$nextTick(()=>{
                let container = this.$el.querySelector(".form__private-zone");
                container.scrollTop = container.scrollHeight
            })
        }
    },
    created() {
        setTimeout(()=> {
            this.enterDirectRoom(this.person === 'ad' ? 'aldenisov' : 'vd_iqquantum_com');
        },2000)

    }
};
</script>

<style scoped lang="less">
textarea::placeholder {
        color:#adc7e1;
}
textarea {
    outline: none;
}
.form__room {
    margin-bottom: 4px;
    width: 100%;
    //min-height: 100%;
    &-title {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.64;
        letter-spacing: 0.4px;
        color: #adc7e1;
        text-transform: uppercase;
        padding-left: 12px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-text
        {
            flex-grow: 1;
        }

        &-ico
        {
            margin-right: 12px;
            font-size: 18px;
            line-height: 1;
        }

        &-main
        {
            background: #3D536B;
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.54;
            letter-spacing: 0.4px;
            color: #fff;
            cursor: pointer;
            padding: 10px 12px;
            display: flex;
            align-items: center;

            &-text
            {
                flex-grow: 1;
                margin-left: 12px;
            }

            &-ico
            {
                font-size: 18px;
                color:#718da8;
                line-height: 1;
            }
        }
    }
    &-item {
        border-bottom: 1px solid #35485e !important;
        display: flex;
        cursor: pointer;
        background:#3D536B;
        &-call {
            border-radius: 0;
            padding: 12px 0;
            &-text {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-align: left;
                color: #374b62;
                text-transform: uppercase;
            }
            &-icon {
                font-size:18px;
                color: #374b62;
                margin-left: 28px;
                margin-right: 34px;
            }
        }
        &-main {
            display: flex;
            cursor: pointer;
            min-width: 360px;
            &:hover {
              background: #adc4e1;
            }
        }
        &:hover i {
            color:#fff;
        }
        &-wrap {
            background-color: #3d536b;
            border-radius: 4px;
        }
        &-ico {
            align-self: center;
            padding-right: 12px;
            i {
                font-size: 20px;
                color:#718da8;
            }
            &-status {
                background-color: #00ffd0;
                border-radius: 12px;
                font-family: Roboto;
                font-size: 13px;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: 0.4px;
                padding: 0px 8px;
            }
        }
        &-data {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &-wrap {
                display: flex;
                flex-grow: 1;
                box-sizing: border-box;
                &-main {
                  display: flex;
                  flex-grow: 1;
                  border-bottom: 1px solid #324258;
                  box-sizing: border-box;
                }
                &-last {
                    display: flex;
                    flex-grow: 1;
                    border-bottom: none;
                }
            }
            &-name {
                font-family: Arimo;
                font-style: normal;
                font-weight: bold;
                font-size: 15px;
                line-height: 20px;
                letter-spacing: 0.4px;
                color: #FFFFFF;
            }
            &-status {
                font-family: Arimo;
                font-style: normal;
                font-weight: normal;
                font-size: 13px;
                letter-spacing: 0.4px;
                color: #ADC4E1;
                line-height: 1.54;
                letter-spacing: 0.4px;
                text-align: left;
                text-overflow: clip;
                white-space: nowrap;
                overflow: hidden;
                max-width: 200px;
            }
        }
        &-avatar {
            padding: 12px 16px 12px 12px;
            &-img {
                z-index: 1;

            }
            &-img-wrap {
                max-width: 56px;
                position: relative;
            }
            &-status {
                width: 8px;
                height: 8px;
                background-color: #00ffd0;
                border-radius: 8px;
                border: solid 3px #adc4e1;
                z-index: 2;
                &-main {
                    width: 8px;
                    height: 8px;
                    background-color: #00ffd0;
                    border-radius: 8px;
                    z-index: 2;
                    border: solid 3px #324258;
                }
                &-new-message {
                    width: 8px;
                    height: 8px;
                    background-color: #00ffd0;
                    border-radius: 8px;
                    margin: 8px;
                }
                &-wrap {
                    position: absolute;
                    right: 0;
                }
            }
        }

    }
}
.form__private {
    display: flex;
    position: relative;
    //border-radius: 0 0 4px 4px;
    overflow: hidden;
    //max-height: calc(100vh - 250px);
    &-main {
        display: block;
        position: relative;
    }
    &-zone {
        padding-top: 0px;
        display: flex;
        //animation: change-height-full 0.6s ease-in 1;
        flex-direction: column;
        background-color: #3D536B;
        height: calc(100vh - 184px);
        overflow: auto;
        box-sizing: border-box;
        width: 360px;
        &-minimaze {
            padding-top: 0px;
            display: flex;
            //animation: change-height-minimaze 0.6s ease-in 1;
            flex-direction: column;
            background-color: #3D536B;
            height: calc(100vh - 549px);
            overflow: auto;
            box-sizing: border-box;
            max-width: 360px;
        }
        &-main {
            overflow: auto;
            max-height: ~"calc(100vh - 172px)";
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
        }
        &-wrap {
            padding: 0 0 55px;
        }
        &-message_card {
            &-wrap {
                display: flex;
                align-items: flex-end;
            }
            &-avatar {
                min-width: 36px;
                flex-basis: 36px;
                margin-left: 12px;
                img {
                    border-radius: 36px;
                }
            }
            &-in {
                border-radius: 4px;
                background-color: #cce0f8;
                margin:4px 12px 4px 12px;
                &-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: solid 1px #374b62;
                    padding: 8px;
                    font-family: Arimo;
                    font-size: 13px;
                    font-weight: bold;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.54;
                    letter-spacing: 0.4px;
                    color: #ffffff;
                    &-text {
                        flex-grow: 1;
                        text-align: left;
                        span {
                            font-weight: normal;
                            font-style: normal;
                            font-stretch: normal;
                            line-height: 1.23;
                            letter-spacing: 0.4px;
                            color: #adc7e1;
                        }
                    }
                    &-ico
                    {
                        font-size: 23px;
                        color:#718da8;
                    }

                    &-avatar
                    {
                        max-width: 36px;
                        margin-right: 12px;

                        img
                        {
                            border-radius: 36px;
                        }
                    }
                }
            }
            &-out{
                margin:8px 12px 8px 12px;
                background: #fff;
                border-radius: 4px;
            }
            &-text {
                font-family: Roboto;
                font-size: 15px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.33;
                letter-spacing: normal;
                color: #506b89;
                padding: 8px 12px 8px 12px;
            }
            &-img {
                padding: 8px 12px 0px 12px;
            }
            &-date{
                font-family: Roboto;
                font-size: 13px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: normal;
                color: #adc7e1;
                display: flex;
                justify-content: space-between;
                padding: 0px 12px 8px 12px;

                &-ico
                {
                    font-size: 18px;
                    line-height: 1;
                }
            }
        }
        &-type__zone {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 4px;
            border-radius: 0 0 4px 4px;
            background-color: #3D536B;
            position: absolute;
            height: 69px;
            bottom:0;
            min-width: 100%;
            box-sizing: border-box;
            z-index: 1;
            &-send-file__icon {
                font-size: 27px;
                color:#718da8;
                align-self: flex-end;
                background: #506b89;
                border-radius: 20px 0 0 20px;
                max-height: 32px;
                &:hover {
                    color:#fff;
                }
                &-wrap {
                    transform: rotate(-45grad);
                }
            }
            &-send__icon{
                font-size: 24px;
                color:#718da8;
                align-self: flex-end;
                background: #506b89;
                border-radius: 0 20px 20px 0;
                height: 61px;
                display: flex;
                align-items: center;
                padding-right: 7px;
                box-sizing: border-box;
                &:hover {
                    color:#fff;
                }
                i {
                    padding-top:3px;
                }
            }
            &-textarea {
                flex-grow: 1;
                display: flex;
                height: 61px;
                //max-height: 32px;
                textarea {
                    resize: none;
                    width: 100%;
                    background-color: #506B89;
                    border-radius: 20px 0 0 20px;
                    padding-left: 20px;
                    padding-top: 4px;
                    box-sizing: border-box;
                    font-family: Roboto;
                    font-size: 15px;
                    font-weight: normal;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.33;
                    letter-spacing: normal;
                    color: #cae4ff;
                    border: none;
                    outline: none;
                }
            }
        }
    }
}

@keyframes change-height-minimaze {
    from {
        height: calc(100vh - 549px);
    }
    to {
        height: calc(100vh - 352px);
    }
}
.changeToMin {
  animation: change-height-minimaze 0.6s ease-in 1;
}
@keyframes change-height-full {
    from {
        height: calc(100vh - 352px);
    }
    to {
        height: calc(100vh - 549px);
    }
}
.changeToFull {
  animation: change-height-full 0.6s ease-in 1;
}
</style>
